
















import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';

@Component({
  name: 'ImageModal',
})
export default class ImageModal extends Vue {
  @Prop({type: String, default: null}) readonly src!: string;
  @Prop({type: String, default: null}) readonly login!: string;

  onModalHide(): void {
    this.$emit('hide');
  }
}
